/**
 * Shared week-grid primitives — Dispatch board, Timesheets and the Tech week view
 * all draw the same day header (small-caps weekday + bold day number, today in blue)
 * and the same left-hand tech cell (colour dot · name · subtitle).
 */
import { format, isSameDay } from "date-fns";

export const WEEK_TECH_COL = "150px";
export const weekGridCols = (days) => `${WEEK_TECH_COL} repeat(${days}, minmax(0, 1fr))`;

export function WeekDayHeader({ day, dense = false, testId }) {
  const today = isSameDay(day, new Date());
  return (
    <div className={`${dense ? "p-1.5" : "p-2"} text-center border-b border-r border-slate-300 last:border-r-0 ${today ? "bg-blue-50" : "bg-slate-50"}`} data-testid={testId} data-today={today ? "true" : "false"}>
      <div className="text-[9px] uppercase tracking-wide text-slate-400">{format(day, "EEE")}</div>
      <div className={`${dense ? "text-xs" : "text-sm"} font-bold leading-tight ${today ? "text-blue-600" : "text-slate-700"}`}>{format(day, "d")}</div>
    </div>
  );
}

export function WeekCornerHeader({ children = "Tech", dense = false }) {
  return <div className={`${dense ? "p-1.5" : "p-2"} bg-slate-50 text-[10px] font-semibold uppercase tracking-wide text-slate-500 border-b border-r border-slate-300 flex items-end`}>{children}</div>;
}

export function TechCell({ tech, subtitle, right, children, testId }) {
  return (
    <div className="p-2 border-b border-r border-slate-300 bg-white flex flex-col gap-1 min-w-0" data-testid={testId}>
      <div className="flex items-center gap-1.5 min-w-0">
        <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: tech?.color || "#64748b" }} />
        <span className="text-xs font-semibold text-slate-800 truncate">{tech?.name || "—"}</span>
        {right && <span className="ml-auto shrink-0">{right}</span>}
      </div>
      {subtitle && <div className="text-[10px] text-slate-400 truncate pl-4">{subtitle}</div>}
      {children}
    </div>
  );
}
